import { render, staticRenderFns } from "./setSetmeal.vue?vue&type=template&id=0163717c&scoped=true&"
import script from "./setSetmeal.vue?vue&type=script&lang=js&"
export * from "./setSetmeal.vue?vue&type=script&lang=js&"
import style0 from "./setSetmeal.vue?vue&type=style&index=0&id=0163717c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0163717c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0163717c')) {
      api.createRecord('0163717c', component.options)
    } else {
      api.reload('0163717c', component.options)
    }
    module.hot.accept("./setSetmeal.vue?vue&type=template&id=0163717c&scoped=true&", function () {
      api.rerender('0163717c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/setSetmeal.vue"
export default component.exports